module.exports = {
    MAX_SCENARIOS: 20,
    GROSS_MARGIN_FIELDS: ['SeedCosts', 'NFertiliserCost', 'IrrigationCosts', 'OtherVariableCosts', 'ExpectedPriceReceived'],
    GROSS_MARGIN_RESULT_FIELD: "grossMargin",
    TRIANGULAR_DISTIRBUTION_RESULT_FIELD: "wetYield",
    TRIANGULAR_DISTRIBUTION_ROW_COLOR: "#E5E5E5",
}
